export const prefix = 'administration.monitor.finishCourse'
